import React from 'react'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'

import T from 'components/FormattedMessage'

import GameCardButton from '../GameCardButton'
import GameCardHeader from '../GameCardHeader'
import GameCardContent from '../GameCardContent'
import QuizIntroButtonIcon from './components/QuizIntroButtonIcon'

import shield from './assets/shield.png'
import background from './assets/bg.png'

interface Props {
  homeTeam: string,
  awayTeam: string,
  imageUrl?: string,
  onClose?: () => (Promise<void> | void),
}

const styles = (theme: Theme) => createStyles({
  root: {
    filter: 'drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1))',
  },
  content: {
    position: 'relative',
    paddingTop: 12,
    paddingBottom: 60,
    backgroundSize: 'auto 60px',
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom center',
  },
  close: {
    top: 0,
    right: 0,
    position: 'absolute',
  },
  closeIcon: {
    color: theme.palette.grey[500],
    width: 12,
    height: 12,
  },
  image: {
    height: 100,
  },
  title: {
    lineHeight: 1.2,
    marginBottom: theme.spacing(),
  },
  description: {
    color: theme.palette.grey[500],
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const QuizIntro: React.SFC<InjectedProps> = ({
  classes,
  onClose,
  homeTeam,
  awayTeam,
  imageUrl,
  ...props
}) => {
  return (
    <div className={classes.root}>
      <GameCardHeader homeTeam={homeTeam} awayTeam={awayTeam} separator={` : `} />
      <GameCardContent className={classes.content} variant="quiz" separated>
        <IconButton onClick={onClose} className={classes.close}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
        <Grid alignItems="center" container>
          <Grid item>
            <img src={imageUrl || shield} className={classes.image} alt="Quiz Daily Challenge Logo" />
          </Grid>
          <Grid xs item>
            <Typography className={classes.title} variant="h6">
              <T id="quiz_intro_title" defaultMessage="Answer daily & earn bonus" />
            </Typography>
            <Typography className={classes.description}>
              <T
                id="quiz_intro_message"
                defaultMessage="Every day a question. Answer correct and earn point multiple."
              />
            </Typography>
          </Grid>
        </Grid>
      </GameCardContent>
      <GameCardButton
        icon={QuizIntroButtonIcon}
        label={<T id="quiz_intro_button" defaultMessage="GOT IT!" />}
        onClick={onClose}
        color="dark"
        clipped
      />
    </div>
  )
}

QuizIntro.defaultProps = {
  imageUrl: shield,
}

export default withStyles(styles)(QuizIntro)
